"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomJsonRpcProvider = exports.CustomFallbackProvider = exports.CustomProvider = exports.addresses = exports.utils = exports.typechain = exports.es = void 0;
var typechain = __importStar(require("./typechain"));
exports.typechain = typechain;
var custom_providers_1 = require("./custom-providers");
Object.defineProperty(exports, "CustomProvider", { enumerable: true, get: function () { return custom_providers_1.CustomProvider; } });
Object.defineProperty(exports, "CustomFallbackProvider", { enumerable: true, get: function () { return custom_providers_1.CustomFallbackProvider; } });
Object.defineProperty(exports, "CustomJsonRpcProvider", { enumerable: true, get: function () { return custom_providers_1.CustomJsonRpcProvider; } });
var utils = __importStar(require("./utils"));
exports.utils = utils;
var addresses_1 = require("./addresses");
Object.defineProperty(exports, "addresses", { enumerable: true, get: function () { return addresses_1.addresses; } });
exports.es = {
    typechain: typechain,
    utils: utils,
    addresses: addresses_1.addresses,
    CustomProvider: custom_providers_1.CustomProvider,
    CustomFallbackProvider: custom_providers_1.CustomFallbackProvider,
    CustomJsonRpcProvider: custom_providers_1.CustomJsonRpcProvider,
};
//# sourceMappingURL=index.js.map